define('subscriptions_addons_list.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('subscriptions_addons_list', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-type=\"backbone.collection.view.rows\"></div>  ";
},"useData":true}, 'extensions/UnlockCommerce/Summit/3.6.0/', 'extensions/UnlockCommerce/Summit/3.6.0/', Handlebars);
});